import { memo, useEffect, useState } from "react";
import { MiActivityLog } from "@mibuildweb/components";

export const CloseoutActivity = memo(
  ({
    open = true,
    attemptModifiedOn,
    dataProcessedTime,
    activities,
    getAttemptActivities,
    isLoading = false,
  }) => {
    const [dateRange, setDateRange] = useState({
      startDate: null,
      endDate: null,
    });

    useEffect(() => {
      if (open) {
        getAttemptActivities(dateRange);
      }
    }, [
      open,
      dataProcessedTime,
      attemptModifiedOn,
      getAttemptActivities,
      dateRange,
    ]);

    const handleDateRangeChange = (newRange) => {
      setDateRange(newRange);
    };

    return (
      <MiActivityLog
        activities={activities}
        isLoading={isLoading}
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
      />
    );
  }
);
